<svelte:options accessors={true} />

<script>
	import Cookies from 'js-cookie'
	import { onMount } from 'svelte';
	import Auth from './Auth.svelte'
	import Info from './Info.svelte'
	import Instructions from './Instructions.svelte'

	export let page = 'info'
	export let loaded = false
	export let auth
	export let info
	export let account
	export let accountVersion = 0
	export let refById = window.uriValue('ref') || ''
	
	export function pageChange(newPage) {
		page = newPage
	}

	export async function request(data,props={}) {
		data.session = sessionId()
		data.refById = refById
		let result = await window.backend(data,props)
		if (typeof result.session !== 'undefined') Cookies.set('sid', result.session, { expires: 365, path: '/' })
		if (typeof result.account !== 'undefined') {
			if ((typeof account === 'undefined') || (JSON.stringify(account) !== JSON.stringify(result.account))) {
				account = result.account
				accountVersion = (new Date()).valueOf()
			}
		}
		return result
	}

	export function sessionId() {
		return Cookies.get('sid')
	}
	
	export async function logout() {
		Cookies.set('sid','',{path: '/'})
		document.location.href='/?'+(new Date().valueOf())
	}

	onMount(() => {
		let sid = window.uriValue('sid')
		if (sid) {
			Cookies.set('sid', sid, { expires: 365, path: '/' })
			document.location.href = `/?ref=${refById}&t=${(new Date().valueOf())}`;
			return
		}
		setTimeout(() => { loaded = true; }, 1000)
	})
	
</script>

{#if loaded}
<div class="h-100 row align-items-center ">
	<div class="d-flex align-items-center justify-content-md-center" style="height:100%;">
		<div class="container p-1" style="width:95%; max-width:500px;">
			{#if (typeof account === 'undefined')}
				<Auth bind:this={auth} />
			{:else if page == 'info'}
				<Info bind:this={info} />
			{:else if page == 'instrution:ios'}
				<Instructions page='ios:start' />
			{:else if page == 'instrution:android'}
				<Instructions page='android:start' />
			{/if}
		</div>
	</div>
</div>
{/if}